import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import PropTypes from "prop-types";
import {isEmpty, parseDate} from "enqc-utilities/src/utils/Utilities";
import label from "enqc-utilities/src/label/Label";
import {Button, Card, Col, Row} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock, faHistory, faUser} from "@fortawesome/free-solid-svg-icons";
import {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import AssemblyHistoryModal from "../AssemblyHistoryModal";
import AssemblyHistoryDetailModal from "../AssemblyHistoryDetailModal";

export default class AssemblyHistoryInformationCard extends BaseComponent{

    constructor(props) {
        super(props);
        let {assembly} = this.props
        if(isEmpty(assembly)){
            assembly = {}
        }
        this.setState({
            assembly,assemblyHistoryCount:0,
            assemblyHistoryModal:false,
            assemblyHistoryDetailModal:false,
            selectedAssemblyHistory:{}
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {assembly} = nextProps
            if(isEmpty(assembly)){
                assembly = {}
            }
            if(assembly!==this.state.assembly && assembly.id){
                this.setState({
                    assembly,
                    assemblyHistoryCount:0,
                    assemblyHistoryDetailModal:false,
                    selectedAssemblyHistory:{}
                }, () => {
                    this.fetchAssemblyHistoryCount()
                })
            }
        }
    }
    fetchAssemblyHistoryCount(){
        let {assembly} = this.state
        if(assembly.id) {
            this.get(Endpoint.API.ASSEMBLY_HISTORY_COUNT, {
                params: {
                    reference: assembly.reference
                }
            }, null, response => {
                if (response.code === 200) {
                    let assemblyHistoryCount = response.data
                    this.setState({
                        assemblyHistoryCount,
                    })
                }
            }, false, true)
        }
    }


    render() {
        let {assembly, assemblyHistoryCount, assemblyHistoryModal, assemblyHistoryDetailModal, selectedAssemblyHistory} = this.state
        if(isEmpty(assembly)){
            assembly = {}
        }
        return (
            <Row>
                <AssemblyHistoryModal
                    show={assemblyHistoryModal}
                    assembly={assembly}
                    onSelect={(selectedAssemblyHistory) => {
                        this.setState({selectedAssemblyHistory, assemblyHistoryDetailModal:true})
                    }}
                    onClose={()=>{
                        this.setState({assemblyHistoryModal:false})
                    }}/>
                <AssemblyHistoryDetailModal
                    assemblyHistory={selectedAssemblyHistory}
                    show={assemblyHistoryDetailModal}
                    onClose={() => {
                        this.setState({assemblyHistoryDetailModal:false})
                    }}
                />
                <Col>
                    <Card border="light" className="shadow-sm p-0 mb-4">
                        <Card.Body>
                            <div className="d-flex align-items-center justify-content-between border-bottom border-light pb-3">
                                <div>
                                    <h6>{label.History}</h6>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between border-bottom border-light py-3">
                                <div>
                                    <h6 className="mb-0"><FontAwesomeIcon icon={faUser} className="icon icon-xs me-3" />{label.Total} {label.Taken}</h6>
                                </div>
                                <div>
                                    <Button
                                        size="sm"
                                        className="fw-normal font-small"
                                        onClick={event => {
                                            this.setState({assemblyHistoryModal:true})
                                        }}>
                                        {assemblyHistoryCount} &nbsp;
                                        <FontAwesomeIcon icon={faHistory} />
                                    </Button>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between pt-3">
                                <div>
                                    <h6 className="mb-0"><FontAwesomeIcon icon={faClock} className="icon icon-xs me-3" />{label.Created}</h6>
                                </div>
                                <div>
                                    {parseDate(assembly.created, DD_MMMM_YYYY_HH_MM_SS)}
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between pt-3">
                                <div>
                                    <h6 className="mb-0"><FontAwesomeIcon icon={faClock} className="icon icon-xs me-3" />{label.Updated}</h6>
                                </div>
                                <div>
                                    {parseDate(assembly.updated, DD_MMMM_YYYY_HH_MM_SS)}
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
    }

}

AssemblyHistoryInformationCard.propTypes = {
    assembly : PropTypes.any,
}